/**
 * PostHog product analytics
 * Only works if the `posthog_product_analytics` feature flag is
 * enabled in FunWithFlags and the posthog key is provided.
 */
import { PostHogConfig } from "posthog-js";
import { PostHogProvider, usePostHog } from "posthog-js/react";
import React from "react";

import { DEFAULT_APP_CONFIG } from "_constants";
import { FeatureFlag, isEnabledFeature } from "utils/featureFlags";

export const TurnPostHogProvider = ({ children }: { children: React.ReactNode }) => {
  const { posthog_key, posthog_host } = window.APP_CONFIG || DEFAULT_APP_CONFIG;
  const posthog = usePostHog();

  // put posthog on window, needed for the toolbar to work
  window.posthog = posthog;

  // get feature flag
  const enabled = isEnabledFeature(FeatureFlag.POSTHOG_PRODUCT_ANALYTICS);

  if (!posthog_key || !posthog_host || !enabled) return <>{children}</>;

  const postHogOptions: Partial<PostHogConfig> = {
    // default: Limited things are stored in the cookie such as the
    // distinctID and the sessionID, and everything else in the browser's localstorage
    persistence: "localStorage+cookie",
    api_host: posthog_host,
    // needed for toolbar
    ui_host: "https://eu.posthog.com",
    // no anonymous profiles
    person_profiles: "identified_only",
    // disable session recording
    disable_session_recording: true,
    // don't capture pageviews in SPA, see PosthogpageView.tsx
    capture_pageview: false,
    // PostHog cookies will be marked as secure, meaning they will only be transmitted over HTTPS.
    secure_cookie: true,
  };

  return (
    <PostHogProvider apiKey={posthog_key as string} options={postHogOptions}>
      {children}
    </PostHogProvider>
  );
};
